




















































































































export default {
  props: {
    messageItems: {
      type: Object,
    },
    curId: {
      type: Number,
    },
    curGroupId: {
      type: String,
    },
  },
  setup(props, { root, emit }: any) {
    console.log(props, { root, emit });
    const filterTag = (text: string) => {
      const reg = /<[^<>]+>/g;
      text && (text = text.replace(reg, ''));
      return text;
    };
    const itemsClick = (messageItems) => {
      emit('itemsClick', messageItems);
      messageItems.unread = 0;
    };
    return {
      filterTag,
      itemsClick,
    };
  },
};
